// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "ink-academy.firebaseapp.com",
  "projectId": "ink-academy",
  "storageBucket": "ink-academy.appspot.com",
  "messagingSenderId": "569266560460",
  "appId": "1:569266560460:web:ecea8e3c93e4752cc75169",
  "measurementId": "G-KSMVDGZ2S7",
  "apiKey": "AIzaSyBRiJq69qtpZTnfqNq_owFF0CYa1Xi-og0"
};
